import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  requests: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  },
  stats: {
    total: 0,
    pending: 0,
    accepted: 0,
    rejected: 0,
    deleted: 0,
  },
  loading: false,
  error: null,
};

export const manualReviewRequests = createSlice({
  name: 'manualReviewRequests',
  initialState,
  reducers: {
    setRequests: (state, action) => {
      state.requests = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateRequestInStore: (state, action) => {
      const index = state.requests.findIndex(r => r._id === action.payload._id);
      if (index !== -1) {
        state.requests[index] = { ...state.requests[index], ...action.payload };
      }
    },
    removeRequestFromStore: (state, action) => {
      state.requests = state.requests.filter(r => r._id !== action.payload);
    },
    setStats: (state, action) => {
      state.stats = { ...state.stats, ...action.payload };
    },
  },
});

export const {
  setRequests,
  setPagination,
  setLoading,
  setError,
  updateRequestInStore,
  removeRequestFromStore,
  setStats,
} = manualReviewRequests.actions;

export default manualReviewRequests.reducer;
